import {
  CourseLicensePreviewRequestDTO,
  CreateUpdateCourseLicenseTemplateApiDTO,
  ValidateLicenseTemplateReplacersDTO,
  ValidatePlaceholderResponse
} from '@/jbi-shared/dto/jtms.dtos';
import {
  CourseLicenseTemplateQueryParams,
  CourseLicenseTemplateReplacer,
  PaginatedCourseLicenseTemplate,
  UpdateCourseLicenseTemplateApiDTO
} from './../store/modules/jtms/course-license-template/course-license-template.types';
import { axios } from './axios';

export const courseLicenseTemplateApi = {
  getPaginatedCourseLicenseTemplate(params: CourseLicenseTemplateQueryParams) {
    return axios.get<PaginatedCourseLicenseTemplate>(
      '/course-license-templates',
      { params }
    );
  },

  getAvailableReplacers() {
    return axios.get<CourseLicenseTemplateReplacer[]>(
      '/course-license-templates/available-replacers'
    );
  },

  validateLicenseTemplatePlaceholders(
    payload: ValidateLicenseTemplateReplacersDTO
  ) {
    return axios.post<ValidatePlaceholderResponse>(
      '/course-license-templates/validate-placeholders',
      payload
    );
  },

  createCourseLicenseTemplate(
    payload: CreateUpdateCourseLicenseTemplateApiDTO
  ) {
    return axios.post('/course-license-templates', payload);
  },

  generateCourseLicensePreviewFromTemplate(
    payload: CourseLicensePreviewRequestDTO
  ) {
    return axios.post('/course-license-templates/generate-preview', payload);
  },

  updateCourseLicenseTemplate(payload: UpdateCourseLicenseTemplateApiDTO) {
    return axios.patch(
      `/course-license-templates/${payload.courseLicenseTemplateId}`,
      payload
    );
  },

  deleteCourseLicenseTemplate(id: number) {
    return axios.delete(`/course-license-templates/${id}`);
  }
};
